module.exports = "../images/fishing-lodge-3-27.jpg?v=508012c";